export const allConsonantsTranscription  = 'jbtṯgǧḥḫdḏrzsšṣḍṭẓzẓʿġfqklmnhwyʾŧpx' +
    'JBṮǦḤḪDḎRZSŠṢḌṬZZZCĠFQKLMNHWYŧPX'; // alle Konsonanten (in Umschrift und in Großbuchstaben) (das x ist dabei, da es zwischendurch in der Konvertierung für Hamza steht)
export const shadda  = 'ّ';
export const all = '-.\'' + allConsonantsTranscription  + 'ãāuaiūāī%°+'; // alle Buchstaben, die innerhalb eines Wortes vorkommen können, also nicht eine Wortgrenze markieren
export const allArabic = '‎رزسإِشصضطظزظعغفقكلمنهويءىةابتثجحؤأئخدذ' + 'َُِ' + shadda ;
export const sunLetters = 'tṯdḏrzsšṣḍṭẓln';
export const wordEndTranscription  = ' ,.()\r\n¡'; // umgedrehtes Ausrufezeichen als Hilfe für Umwandlung am Wortende
export const typeDirectToArabicArray = [
    'a', 'b', 'c', 'd', 'e', 'f',
    'g', 'h', 'i', 'j', 'k', 'l',
    'm', 'n', 'o', 'p', 'q', 'r',
    's', 't', 'u', 'v', 'w', 'x',
    'y', 'z',
    '2', '3', '5', '6', '7', '9',
    'A', 'C', 'D', 'E', 'F', 'G',
    'H', 'I', 'K', 'L', 'O', 'P',
    'S', 'T', 'U', 'V', 'X', 'Y',
    'Z'
];

export const arabicDirectFromTypeArray = [
    'ا', 'ب', 'ث', 'د', 'ِ', 'ف',
    'غ', 'ه', 'ي', 'ج', 'ك', 'ل',
    'م', 'ن', 'ُ', 'ى', 'ق', 'ر',
    'س', 'ت', 'و', 'َ', 'و', 'ش',
    'ي', 'ز',
    'ء', 'ع', 'خ', 'ط', 'ح', 'ص',
    'أ', 'ذ', 'ض', 'ٍ', 'َ', 'ً',
    'ة', 'إ', 'ِ', 'ٍ', 'ٌ', 'آ',
    'ْ', 'ة', 'ؤ', 'ً', 'ّ', 'ئ',
    'ظ'
];

export const transcriptionInputArray = [
    /á/, /í/, /ú/, /´/,
    / /,
    /a\~/,
    /a%/, /a°/, // nicht ausgesprochenes Alif
    /i-y/, /u-w/,
    /lla-/, // aus irgendeinem Grund wird lam-lam-alif nicht richtig dargestellt, wenn das Fatha auf dem Shadda fehlt. Daher hier Extra
    /y/, /r/, /z/, /s/, /f/,  // 1-5
    /q/, /k/, /l/, /m/, /n/,  // 6-10
    /h/, /w/, /d/, /t/, /b/,  // 11-15
    /i/, /u/, /a/, /i\-/, /u\-/,  // 16-20
    /c-/, // Dschim mit 3 Punkten
    /g\./, /c/, /z\./, /t\./, /d\./, // 21-25
    /G\./, /C/, /Z\./, /T\./, /D\./, // 21-25 Großbuchstaben
    /s\./, /s\-/, /d\-/, /h\-/, /h\./, // 26-30 
    /S\./, /S\-/, /D\-/, /H\-/, /H\./, // 26-30 Großbuchstaben
    /a\-/, /g\-/, /t\-/, /g\./, /d\./, // 31-35
    /A\-/, /G\-/, /T\-/, // 31-35 Großbuchstaben
    /\'/, // Hamza 32
    /G/, // G wird in der Aussprache zu G, in der Umschrift zu g-
    /o/, /e/, // 33 - 34
    // Sachen, die nur zur Umschrift gebraucht werden
    /o\-/, /e\-/, /H:/, /h:/, /:/, /;/,
    /\//,
    /z-/,
    /j/, /J/, /´/,
    /U\-/, /U/, /I\-/, /I/, /A\-/, /A/,
    /ŧī/, /ŧū/, /ŧā/ // zum Umwandeln (eigentlich falsch eingegeben) von Ta Marbuta plus Langem Vokal (dies muss nach Ta Marbuta (s. oben) kommen)
    , "o", "e",
    "ō", "ē"
    , /\+/ // + als Alternative zu Slash zur Abtrennung von Nunation
];
export const alifMaks = 'ã';//' ̰a';//'a̠';
export const alifKreisDrueber = 'ⱥ';
export const jimThreeDots = 'č';
export const hamza = 'ʾ';
export const taMarbuta = 'ŧ'; 
export const transcriptionArray = [
    "'a", "'i", "'u", "'",
    // "ay", "aw",
    " ", alifMaks,
    alifKreisDrueber, alifKreisDrueber,
    "iyy", "uww",
    "llā",
    "y", "r", "z", "s", "f",
    "q", "k", "l", "m", "n",
    "h", "w", "d", "t", "b",
    "i", "u", "a", "ī", "ū",
    jimThreeDots,
    "ġ", "ʿ", "ẓ", "ṭ", "ḍ",
    "Ġ", "ʿ", "Z", "Ṭ", "Ḍ",
    "ṣ", "š", "ḏ", "ḫ", "ḥ",
    "Ṣ", "Š", "Ḏ", "Ḫ", "Ḥ",
    "ā", "ǧ", "ṯ", "ġ", "ḍ",
    "Ā", "Ǧ", "Ṯ",
    hamza,
    "ǧ",
    "o", "e",
    "ō", "ē", taMarbuta, taMarbuta, taMarbuta, taMarbuta,
    "/",
    'ž',
    "ǧ", "Ǧ", hamza,
    "Ū", "u", "Ī", "i", "Ā", "a",
    "tī", "tū", "tā"
    , "u", "i",
    "ū", "ī"
    , "/"
];

export const transcriptionSpecialInputArray = [
    '(&b)' + hamza + 'ana' + '(&b)'
    , '(&b)li_al-' // li_al-kita-b
    , '(&b)li_l-' // li_l-kita-b
];

export const transcriptionSpecialArray = [
    '$1' + hamza + 'anā$2',
    '$1li_l-' // li_al-kita-b
    , '$1li_l-' // li_al-kita-b
];

export const transcriptionFinalVowelsInputArray = [
	// bei bi, wa, min, ʿan (can) usw. keine Nunation annehmen
	'(&W)bi(&W)', '(&W)li(&W)', '(&W)wa(&W)', 
	'(&W)min(&W)', '(&W)man(&W)', '(&W)ʿan(&W)', '(&W)ʾan(&W)', '(&W)\'ana(&W)', 
	'([^\/])an(&W)', '([^\/])a(&W)', 	'([^\/])an$', '([^\/])a$',
	'([^\/])in(&W)', '([^\/])i(&W)',	'([^\/])in$', '([^\/])i$',
	'([^\/])un(&W)', '([^\/])u(&W)',	'([^\/])un$', '([^\/])u$'
	,'í', 'á'
];

export const transcriptionFinalVowelsArray = new Array (
	'$1bí$2', '$1lí$2', '$1wá$2',  '$1mín$2', '$1mán$2',  '$1ʿán$2', '$1ʾán$2', '$1\'áná$2',   
	'$1/an$2', '$1/a$2', 	'$1/an', '$1/a', 
	'$1/in$2', '$1/i$2', '$1/in', '$1/i', 
	'$1/un$2', '$1/u$2', '$1/un', '$1/u' 
	,'i', 'a'
);
